import { useCallback, useEffect, useState } from 'react';
import type { User, BusinessUser, Request, SupportTicket } from '../types/usersDemo';
import { mockDrawerRequests, mockDrawerSupportTickets } from '../data/mock/usersDemo';

const shouldUseMocks = (): boolean => {
  try {
    return String(import.meta.env.VITE_USE_MOCKS).toLowerCase() === 'true';
  } catch {
    return true;
  }
};

export function useDrawerRequests(contact: User | BusinessUser | null) {
  const [requests, setRequests] = useState<Request[]>([] as any);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const load = useCallback(async () => {
    if (!contact) return;
    setLoading(true);
    setError(null);
    try {
      if (shouldUseMocks()) {
        setRequests(mockDrawerRequests as any);
      } else {
        setRequests(mockDrawerRequests as any); // replace with API when available
      }
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [contact]);

  useEffect(() => { load(); }, [load]);

  return { requests, loading, error, refetch: load };
}

export function useSupportTickets(contact: User | BusinessUser | null) {
  const [tickets, setTickets] = useState<SupportTicket[]>([] as any);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const load = useCallback(async () => {
    if (!contact) return;
    setLoading(true);
    setError(null);
    try {
      if (shouldUseMocks()) {
        setTickets(mockDrawerSupportTickets as any);
      } else {
        setTickets(mockDrawerSupportTickets as any); // replace with API when available
      }
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [contact]);

  useEffect(() => { load(); }, [load]);

  return { tickets, loading, error, refetch: load };
}


